/**
 * Foundation init
 */
$(document).foundation();
/**
 * Callout
 */
$.fn.callout = function (message, type) {
    return $(this).html('<div class="' + type + '">' + message + '</div>');
};
/**
 * Ajax
 */
var ajax = 'ajax.php?action=';
var dir = '/';
var pagination = $('#pagination_conf').val();

/**
 * On load check if logged
 */
$(window).on('load', function () {
    $.get(ajax + 'is_logged', function (data) {

// If non true and not login page
        if (!data && window.location.pathname != dir + 'login.html') {

            // Redirect to login page
            window.location.href = dir + 'login.html';
        } else if (data && window.location.pathname == dir + 'login.html') {

// Redirect to index
            window.location.href = dir + 'index.php';
        } else {

// Add logged class to body
            $('body').addClass('logged');
            // Load tables
            $.get(ajax + 'tables', function (data) {

                // Append
                $.each(data, function (index, item) {
                    $('select[name="table"]').append('<option value="' + index + '">' + item + '</option>');
                });
            });
            // Load tables
            loadLeads('all', $('#from').val(), undefined, pagination, 1);

        }
    });
});
/**
 * Delete lead
 * @param string $name table name
 * @param integer $id post id
 * @param object dom
 */
function deleteLead(name, id, dom) {
// Used varables
    var self = this;
    // Response box
    var response = $(this).find('.response');
    // Submit button
    var button = $(this).find('.button');
    // Callout classes
    var classes = {
        success: 'callout success',
        error: 'callout alert',
        loading: 'callout primary'
    };
    $.ajax({
        type: 'GET',
        url: ajax + 'delete',
        data: {
            name: name,
            id: id
        },
        success: function (data) {
            var table_tr = dom.closest('tr');
            if (data.status === 'success') {
                table_tr.addClass('delete').fadeOut('slow');
                response.callout(data.message, classes.success);

            } else {
                response.callout(data.message, classes.error);
            }
            ;
        },
        error: function (data) {

        }
    });
}

/**
 * Set lead status
 * @param integer id_lead
 * @param integer id_status
 * @param object dom
 */
function setStatus(id_lead, table_lead, id_status, dom) {
    $.ajax({
        type: 'GET',
        url: ajax + 'status',
        data: {
            id_lead: id_lead,
            id_status: id_status,
            table_lead: table_lead
        },
        success: function (data) {
            var table_tr = dom.closest('tr');
            var status_label = '';
            if (data.status === true) {
                status_label = table_tr.find('select option:selected').text();
                table_tr
                        .find('.status')
                        .fadeOut('fast')
                        .text(status_label)
                        .fadeIn('fast');

            } else {


            }
            ;
        },
        error: function (data) {
            console.log('error');
            console.log(data);
        }
    });
}

/**
 * Login
 */
$(document).on('submit', 'form.login', function (event) {
    event.preventDefault();
    // Used varables
    var self = this;
    // Response box
    var response = $(this).find('.response');
    // Submit button
    var button = $(this).find('.button');
    // Callout classes
    var classes = {
        success: 'callout success',
        error: 'callout alert',
        loading: 'callout primary'
    };
    // Add loader
    response.callout('Ładowanie...', classes.loading);
    // Ajax submit
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: ajax + 'login',
        data: $(self).serialize(),
        // If success
        success: function (data) {

            // Response
            if (data.status == 'success') {

                // Callout
                response.callout(data.message, classes.success);
                // Redirect to index
                window.location.href = data.redirect;
            } else {

                // Callout
                response.callout(data.message, classes.error);
            }
            ;
        }
    });
});

var tables = {
	
    'all': 'Wszystkie wyniki',
    'leads_bravo': 'Bravo',
    'leads_classic': 'Classic',
    'leads_main': 'Główny',
    'leads_verba': 'Verba',
    'leads_vivagarden': 'Viva Garden',
    'leads_wedding': 'Targi ślubne',
    'leads_ppraga': 'Przystanek Praga',
    'leads_19': '19 lat VD',
    'leads_mieszko': 'Osiedle mieszko',
    'leads_ursusfactory': 'Osiedle Ursus Factory',
    'leads_novaochota': 'Osiedle Nova Ochota',
    'leads_rozwod': 'Mieszkania pod wynajem',
    'leads_parser': 'Wiadomości parsowane',
    'leads_rynekpierwotny':'Rynek pierwotny',
    'leads_variantpraga': 'Variant Praga',
    'leads_mojaochota': 'Moja Ochota',
    'leads_metropolczynska': 'Metro Połczyńska',
    'leads_kontakt': 'Wiadomości wewnętrzne',
};

function getLeadsCount(name, from, to) {
    var count = 0;
    $.ajax({
        type: 'GET',
        url: ajax + 'count',
        async: false,
        data: {
            'name': name,
            'from': from,
            'to': to
        },
        success: function (data) {
            count = data;
        }
    })
    return count[0];
}

/**
 * Load from table with params
 * 
 * @version 
 */
function loadLeads(name, from, to, limit, page) {
    var
            leads_status = {
                0: '---',
                1: 'Potencjalny',
                2: 'Obsługiwany',
                3: 'Rezerwacja',
                4: 'Kupił',
                5: 'Nierokujący',
                6: 'Nieaktywny',
                7: 'test'
            },
            count = getLeadsCount(name, from, to);
    var pagination_num = parseInt(count / pagination);

    // Clear tbody
    $('table.data tbody').html('');
    $('table.data').after('<div class="loader"><span></span></div>');

    // Load tables

    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: ajax + 'table',
        data: {
            'name': name,
            'from': from,
            'to': to,
            'limit': limit,
            'page': page
        },
        // If success

        success: function (data) {
            var lead_status_box;
            // Clear tbody
            $('table.data tbody').html('');
            $('.loader').remove();
            $('td.selected').remove();
            // Append
            var template = '';
            $.each(data.data, function (index, item) {

                // Row template

                /**
                 * Show full table header
                 */
                $('table.data thead tr td').show();
                // If no rooms
                if (item.rooms == '' || item.rooms == '0') {
                    item.rooms = 'Inne';
                }

                // Ref
                if (item.ref == '') {
                    item.ref = 'direct/organic';
                }
                $('table.data thead tr td').show();


                // Setup
                template += '<tr>';
                template += '<td>' + item.id + '</td>';
                template += '<td>' + (item.name !== 'undefined' && item.name !== null ? item.name : '') + '</td>';
                template += '<td>' + (item.email !== 'undefined' && item.email !== null ? item.email : '') + '</td>';
                template += '<td>' + (item.phone !== 'undefined' && item.phone !== null ? item.phone : '') + '</td>';
                template += '<td>' + item.date + '</td>';
                template += '<td>' + (item.selected !== 'undefined' && item.selected !== null ? item.selected : tables[item.type]) + '</td>';
                template += '<td>' + (item.rooms !== 'undefined' && item.rooms !== null ? item.rooms : '') + '</td>';
                template += '<td>' + (item.ref !== 'undefined' && item.ref !== null ? item.ref : '') + '</td>';
                //template += '<td>' + (item.lead_id !== 'undefined' && item.lead_id !== null ? item.lead_id : '') + '</td>';
                template += '<td>' + (item.type !== null ? tables[item.type] : '') + '</td>';
                template += '<td class="status">' + (item.id_status !== null ? leads_status[item.id_status] : '') + '</td>';

                if (name === 'unparsemails') {
                    template += '<td><a href="#delete" class="action" data-id="' + item.id + '">Usuń</a></td>';
                } else {
                    /**
                     * to refactore on the Symfony
                     */
                    lead_status_box = '<select class="lead_status" name="lead_status">';
                    $.each(leads_status, function (key, value) {
                        lead_status_box
                                += '<option value="'
                                + key + '" ' + (key === item.id_status ? 'selected' : '') + '>'
                                + value
                                + '</option>';
                    });

                    lead_status_box += '</select>';
                    template += '<td>' + lead_status_box + '</td>';
                }
                template += '</tr>';
                // Append

            });


            $('table.data tbody').append(template);

            if (name === 'unparsemails') {
                $('table.data thead tr td').eq(9).hide();
                $('table.data thead tr td').eq(8).hide();
                $('table.data thead tr td').eq(7).hide();
                $('table.data thead tr td').eq(6).hide();
                $('table.data thead tr td').eq(5).hide();
                $('table.data thead tr td').eq(3).hide();
                $('table.data thead tr td').eq(1).hide();
                $('table.data tbody tr').each(function () {
                    var td = $(this).find('td');
                    td.eq(9).hide();
                    td.eq(8).hide();
                    td.eq(7).hide();
                    td.eq(6).hide();
                    td.eq(5).hide();
                    td.eq(3).hide();
                    td.eq(1).hide();
                });
            }
            $(document).find('.pagination').remove();
            var pagination = '';
            pagination += '<nav aria-label="Pagination"><ul  class="pagination">';

            for (var index = 1; index <= pagination_num; index++) {
                var current_page = '';
                if (index == page) {
                    current_page = 'current';
                }
                pagination += '<li class="' + current_page + '"><a href="#">' + index + '</a></li>';
            }
            pagination += '</ul></nav>';
            $('.content').append(pagination);
        },
        error: function (data) {
            console.log(data);
        }
    });

}



/**
 * Table row Actions
 */
$(document).on('click', 'a.action', function () {

    deleteLead($('select[name="table"]').val(), parseInt($(this).data('id'), pagination), $(this));
    return false;
});
/**
 * On change lead status
 */
$(document).on('change', '.lead_status', function () {
    var
            id_lead = $(this).closest('tr').find('td').first().text(),
            table_lead = $(document).find('#table').val(),
            id_status = $(this).val();
    if (id_status != '0') {
        setStatus(id_lead, table_lead, id_status, $(this));
    }
});
/**
 * On change table
 */
$(document).on('change', '#table, #from, #to,#pagination_conf', function () {
    pagination = $('#pagination_conf').val();
    loadLeads($('select[name="table"]').val(), $('#from').val(), $('#to').val(), pagination, 1);
});

$(document).on('click', '.pagination a', function (e) {
    e.preventDefault();
    loadLeads($('select[name="table"]').val(), $('#from').val(), $('#to').val(), pagination, $(this).text());
    $('.pagination li').removeClass('current');
    $(this).closest('li').addClass('current');
    return false;
});

/**
 * On change table
 */
$(document).on('click', '.button--reset', function () {

    // Reset
    $('#from, #to').val('');
    // Force update
    loadLeads($('select[name="table"]').val(), $('#from').val(), $('#to').val(), pagination, 1);
});
/**
 * Table to CSV
 */
$(document).on('click', '.button--export', function () {
    $('table.data').TableCSVExport({
        delivery: 'download'
    });
});
/**
 * Logout
 */
$(document).on('click', 'a[href="#logout"]', function () {

    // Logout by ajax
    $.get(ajax + 'logout', function (data) {

        // Redirect to login page
        window.location.href = dir + 'login.html';
    });
});
/**
 * Datapicker
 */
var nowTemp = new Date();
var now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);
// Checkin
$('#from, #to').fdatepicker({
    // Options
    format: 'yyyy-mm-dd hh:ii',
    disableDblClickSelection: true,
    language: 'pl',
    pickTime: true,
    minView: 1
});
